import { render, staticRenderFns } from "./RestaurantStateCard.vue?vue&type=template&id=c093889a&scoped=true&"
import script from "./RestaurantStateCard.vue?vue&type=script&lang=js&"
export * from "./RestaurantStateCard.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantStateCard.vue?vue&type=style&index=0&id=c093889a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c093889a",
  null
  
)

export default component.exports